import getPageTag from './pageTag';

const getSpecs = ({ lang }) => {
  return [
    getPageTag(lang),
  ];
};

export default getSpecs;
